import { render, staticRenderFns } from "./ReviewRejected.vue?vue&type=template&id=80c9f006&scoped=true&"
import script from "./ReviewRejected.vue?vue&type=script&lang=js&"
export * from "./ReviewRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c9f006",
  null
  
)

export default component.exports